import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=615aad92&"
import script from "./Insights.vue?vue&type=script&setup=true&lang=js&"
export * from "./Insights.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports